"use client";

import * as React from "react";

import styles from "./DashboardListSidebar.module.css";

export interface DashboardListItem {
  id: string;
  name: string;
  meta?: string;
  audience?: string;
}

export interface DashboardListSidebarProps {
  sections: Array<{
    title: string;
    items: DashboardListItem[];
    onNew?: () => void;
  }>;
  activeId?: string;
  onSelect: (id: string) => void;
}

export function DashboardListSidebar({ sections, activeId, onSelect }: DashboardListSidebarProps) {
  return (
    <aside className={styles.root} aria-label="Dashboards">
      {sections.map((section, sIdx) => (
        <React.Fragment key={`${section.title}-${sIdx}`}>
          <div className={styles.section}>
            <span>{section.title}</span>
            {section.onNew ? (
              <button type="button" className={styles.newButton} onClick={section.onNew}>
                + New
              </button>
            ) : null}
          </div>
          {section.items.map((item) => (
            <button
              key={item.id}
              type="button"
              className={styles.item}
              data-active={item.id === activeId || undefined}
              onClick={() => onSelect(item.id)}
            >
              <span>{item.name}</span>
              {item.meta ? <span className={styles.itemMeta}>{item.meta}</span> : null}
            </button>
          ))}
        </React.Fragment>
      ))}
    </aside>
  );
}
